import React from 'react';
import { useTranslation } from 'react-i18next';
import BaggageIcon from '../Icons/BaggageIcon';

interface Props {
  toggleErrorModal(): void;
}

const ErrorModal: React.FC<Props> = ({ toggleErrorModal }) => {
  const { t } = useTranslation(['includeTeam']);

  return (
    <div className="success-wrapper" data-testid="error-include-modal">
      <div className="icon-wrapper">
        <BaggageIcon />
      </div>
      <span className="title-success">{t('includeTeam:lets_try_again')}</span>
      <span className="subtitle">{t('includeTeam:error_occurred')}</span>
      <button type="button" className="ok-button" onClick={toggleErrorModal}>
        {t('includeTeam:try_again')}
      </button>
    </div>
  );
};

export default ErrorModal;
